const activarTotpInitialState = {
  activarTotp: {
    loading: false,
    error: null,
    data: null,
  },
};

export default activarTotpInitialState;
